import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";

var LoggerClient = /*#__PURE__*/function () {
  function LoggerClient() {
    _classCallCheck(this, LoggerClient);
  }

  _createClass(LoggerClient, null, [{
    key: "post",
    value: function post(config, msgPayload, debugEnabled) {
      var xhr = new XMLHttpRequest();
      xhr.addEventListener('load', function () {
        if (debugEnabled) {
          if (xhr.status < 200 || xhr.status >= 300) {
            // eslint-disable-next-line no-console
            console.debug('log service error - returned ', xhr.status);
          } else {
            // eslint-disable-next-line no-console
            console.info('log service response is ', xhr.response);
          }
        }
      });
      xhr.addEventListener('error', function () {
        if (debugEnabled) {
          // eslint-disable-next-line no-console
          console.debug('log service network error');
        }
      });
      xhr.open('POST', config.logServiceUrl, true);
      xhr.setRequestHeader('Content-Type', 'application/json');
      xhr.send(JSON.stringify(msgPayload));
    }
  }]);

  return LoggerClient;
}();

export { LoggerClient as default };